export default [
  {
    animation: "loading_1.json",
    loop: true,
    position: { top: "0px", left: "0px" },
    width: "100%",
    height: "auto"
  },
  {
    animation: "loading_2.json",
    loop: true,
    position: { top: "0px", left: "0px" },
    width: "100%",
    height: "auto"
  },
  {
    animation: "loading_3.json",
    loop: true,
    position: { top: "0px", left: "0px" },
    width: "100%",
    height: "auto"
  },
  {
    animation: "loading_1.json",
    loop: true,
    position: { top: "0px", left: "0px" },
    width: "100%",
    height: "auto"
  },
  {
    animation: "loading_2.json",
    loop: true,
    position: { top: "0px", left: "0px" },
    width: "100%",
    height: "auto"
  },
  {
    animation: "loading_3.json",
    loop: true,
    position: { top: "0px", left: "0px" },
    width: "100%",
    height: "auto"
  }
];
